
import { Link } from "react-router-dom";
import { Card, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { ArrowRight, Layers } from "lucide-react";
import { AspectRatio } from "@/components/ui/aspect-ratio";

interface ClipCardProps {
  clip: {
    id: string | number;
    title: string;
    playlistName: string;
    thumbnailUrl: string;
    duration: string;
  };
}

export const ClipCard = ({ clip }: ClipCardProps) => {
  return (
    <Link to={`/clip/${clip.id}`} className="group">
      <Card className="overflow-hidden transition-all duration-300 hover:shadow-md h-full">
        <div className="relative">
          <AspectRatio ratio={16/9}>
            <img
              src={clip.thumbnailUrl}
              alt={clip.title}
              className="w-full h-full object-cover transition-transform group-hover:scale-105 duration-300"
              loading="lazy"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
            <div className="absolute bottom-2 right-2 bg-black/70 text-white px-2 py-1 rounded text-xs">
              {clip.duration}
            </div>
            <div className="absolute bottom-3 right-3 bg-white/90 dark:bg-black/70 text-primary rounded-full p-2 shadow-md opacity-0 group-hover:opacity-100 transition-opacity">
              <ArrowRight className="h-4 w-4" />
            </div>
          </AspectRatio>
        </div>
        <CardHeader className="p-3 pb-2">
          <CardTitle className="text-base line-clamp-1">
            {clip.title}
          </CardTitle>
          <CardDescription className="line-clamp-1 text-xs">
            <span className="inline-flex items-center">
              <Layers className="h-4 w-4 mr-1.5" /> {clip.playlistName}
            </span>
          </CardDescription>
        </CardHeader>
      </Card>
    </Link>
  );
};

export default ClipCard;
